import { render, staticRenderFns } from "./livingGuestReport.vue?vue&type=template&id=b6d6a044"
import script from "./livingGuestReport.vue?vue&type=script&lang=js"
export * from "./livingGuestReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports